import { StyledHeartOfVegas, StyledProductsContainer } from './style';
import { BundleProps } from 'utils/types';
import HeartOfVegasBundlePrice from './BundlePrice';
import { EBadgeType, EGradientDirection, EProductPriority } from 'utils/enums';
import { CSSProperties, useEffect, useMemo, useState } from 'react';
import { BadgeData } from 'components/Badge/types';
import { TooltipTemplate } from 'components/TooltipTemplate';
import tooltipIcon from 'assets/HeartOfVegas/tooltip-icon.png';
import { MainChestProduct } from './Products/MainChestProduct';
import { MainCoinsProduct } from './Products/MainCoinsProduct';
import { LoyaltySubProduct } from './Products/LoyaltySubProduct';
import { IExtendedTooltipProps } from 'components/TooltipTemplate/types';

const tooltipButtonStyle: CSSProperties = {
  position: 'absolute',
  right: '8px',
  marginRight: '4px',
  zIndex: 2,
  cursor: 'pointer',
};

const templateTooltipStyle: CSSProperties = {
  background: '#6f48d8',
  color: '#4F018A',
  maxWidth: 220,
  fontSize: '14px',
  fontWeight: '700',
  lineHeight: '1.5',
  zIndex: '5',
};

const templateAdvancedTooltipStyle: CSSProperties = {
  background: '#3E2893',
  minWidth: 160,
  borderRadius: '7px',
  zIndex: '5',
  padding: '8px',
};

type tooltipType = 'Advanced' | 'Simple' | '';

export const HeartOfVegasBundle: React.FC<BundleProps> = ({
  price,
  productList,
  backgroundSrc,
  backgroundColor = {
    colorOne: '#406cf9',
    colorTwo: '#6449ff',
    gradientDirection: EGradientDirection.TopToBottom,
  },
  bundleButtonColor,
  bundleButtonTextColor,
  badges = [],
  salePercentage = 0,
  tooltipLoadCallback,
}) => {
  const [emblemBadge, setEmblemBadge] = useState<any>(null);
  const [tooltipContent, setTooltipContent] = useState<
    string | IExtendedTooltipProps | null
  >(null);
  const [mainCoinsProduct, setMainCoinsProduct] = useState<any>(null);
  const [mainChestProduct, setMainChestProduct] = useState<any>(null);
  const [loyaltySubProduct, setLoyaltySubProduct] = useState<any>(null);

  useEffect(() => {
    if (Array.isArray(badges) && badges.length > 0) {
      const foundEmblem = badges?.find((b: BadgeData) => {
        return (
          b.badge?.type === EBadgeType.EMBLEM || b.type === EBadgeType.EMBLEM
        );
      });
      setEmblemBadge(foundEmblem?.badge?.emblem || foundEmblem?.emblem);
    } else {
      setEmblemBadge(null);
    }
  }, [badges]);

  useEffect(() => {
    const mainProducts = productList.filter(
      (product) => product.priority === EProductPriority.MAIN,
    );
    setMainCoinsProduct(mainProducts[0]);
    setMainChestProduct(mainProducts[1]);
    setLoyaltySubProduct(
      productList.find((product) => product.priority === EProductPriority.SUB),
    );
  }, [productList]);

  useEffect(() => {
    if (mainChestProduct?.rarityProductInfo?.tooltipText) {
      setTooltipContent(mainChestProduct?.rarityProductInfo?.tooltipText);
    } else if (mainChestProduct?.rarityProductInfo?.tooltip?.length > 0) {
      const tooltip = mainChestProduct.rarityProductInfo.tooltip;
      setTooltipContent({
        sections: tooltip,
        titleImg: mainChestProduct?.images?.product,
        title: mainChestProduct?.displayName || '',
        tooltipLoadCallback: tooltipLoadCallback,
      });
    }
  }, [mainChestProduct]);

  const isSimpleTooltip = useMemo(
    () => typeof tooltipContent === 'string',
    [tooltipContent],
  );

  return (
    <StyledHeartOfVegas
      productColor={
        productList.length > 0 ? productList[0].textFontColorHex : ''
      }
      backgroundSrc={backgroundSrc}
      backgroundColor={backgroundColor}
      className="heart-of-vegas-bundle"
    >
      {emblemBadge && (
        <div className="heart-of-vegas-bundle__emblem-badge">
          <img alt={'emblem-badge'} src={emblemBadge.imageUrl} />
        </div>
      )}
      {tooltipContent && (
        <TooltipTemplate
          buttonStyle={tooltipButtonStyle}
          content={tooltipContent}
          templateTooltipStyle={
            isSimpleTooltip
              ? templateTooltipStyle
              : templateAdvancedTooltipStyle
          }
        >
          <img
            className={'tooltip-icon'}
            src={tooltipIcon}
            alt={'tooltip-icon'}
          ></img>
        </TooltipTemplate>
      )}
      <StyledProductsContainer>
        {mainChestProduct && (
          <MainChestProduct mainProduct={mainChestProduct} />
        )}
        {mainCoinsProduct && (
          <MainCoinsProduct
            mainProduct={mainCoinsProduct}
            salePercentage={salePercentage}
            isOnlyMainProduct={Boolean(mainChestProduct)}
          />
        )}
        {loyaltySubProduct && (
          <LoyaltySubProduct loyaltySubProduct={loyaltySubProduct} />
        )}
      </StyledProductsContainer>
      <HeartOfVegasBundlePrice
        price={price}
        bundleButtonColor={bundleButtonColor}
        bundleButtonTextColor={bundleButtonTextColor}
      ></HeartOfVegasBundlePrice>
    </StyledHeartOfVegas>
  );
};
